export default {
    bloglist: {
        en: [
            // {
            //     title: 'How to Change Fonts on GBWhatsApp Easily',
            //     poster: require('@/assets/blog-1.webp'),
            //     desc: "GBWhatsApp is one of the most popular WhatsApp mods in 2026, loved for its extra features and customization options. Among its most sought-after features is the ability to change fonts in GBWhatsApp — giving your chats a fresh, stylish look.",
            //     name: 'en-blog1',
            //     url: 'https://instasaves.io/how-change-fonts-on-gbwhatsapp/',
            //     date:"2026-08-15",
            // }

         
        ],
    }
    
}
